import { Badge, Card, Form, Stack } from "react-bootstrap";
import Loading from "../components/loading";
import { useCallback, useEffect, useState } from "react";
import InputLabel from '@mui/material/InputLabel';
import api from "../api/api";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SuccessMessage from "../components/successMessage";
import ErrorMessage from "../components/errorMessage";
import { Ban, CalendarCheck, Check } from "lucide-react";
import { Autocomplete, createFilterOptions, Box, Menu, ListItemIcon, Dialog, DialogActions, DialogContentText, DialogTitle, DialogContent } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import MoreVertIcon from '@mui/icons-material/MoreVert';


function Appointment() {

    const navigate = useNavigate();

    const { appointmentId } = useParams();

    const location = useLocation();
    const { appointmentData } = location.state || {};

    const [isLoading, setLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [comboBoxPatients, setComboBoxPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);

    const [showModalToCancelAppointment, setShowModalToDeleteAppointment] = useState(false);

    const [patientPhoneNumber, setPatientPhoneNumber] = useState('');

    const [comboBoxDentists, setComboBoxDentists] = useState([]);
    const [selectedDentistId, setSelectedDentistId] = useState('');

    const [appointmentDate, setAppointmentDate] = useState(dayjs());
    const [appointmentHour, setAppointmentHour] = useState(dayjs());
    const [appointmentDuration, setAppointmentDuration] = useState('');
    const [appointmentObservation, setAppointmentObservation] = useState('');
    const [appointmentType, setAppointmentType] = useState('');
    const [appointmentStatus, setAppointmentStatus] = useState('');
    const [appointmentStatusDescription, setAppointmentStatusDescription] = useState('');

    const filter = createFilterOptions({
        stringify: (option) => option.label
    });

    const getComboBoxPatients = useCallback(() => {
        api.get("/patients/combobox", {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            const options = returnFromApi.data.map(patient => ({
                id: patient.id,
                label: patient.nome,
                phone: patient.whatsapp
            }));
            setComboBoxPatients(options);
        }).catch((returnFromApi) => {
            console.error("ops! ocorreu um erro" + returnFromApi);
            if (returnFromApi.status === 401) {
                navigate("/expired-session");
            }
        });
    }, [navigate]);

    const getComboBoxDentists = useCallback(() => {
        api.get("/dentists/combobox", {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setComboBoxDentists(returnFromApi.data);
        }).catch((err) => {
            setLoading(false);
            console.error("ops! ocorreu um erro" + err);
        });
    }, []);

    const getAppointment = useCallback((appointmentId) => {
        setLoading(true);
        api.get("/appointments/".concat(appointmentId), {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            const appointment = returnFromApi.data
            const selectedPatient = {
                id: appointment.pacienteId,
                label: appointment.nomeDoPaciente
            };
            setSelectedPatient(selectedPatient);
            setPatientPhoneNumber(appointment.whatsappDoPaciente);
            setSelectedDentistId(appointment.dentistaId);
            setAppointmentDate(dayjs(appointment.data, "DD/MM/YYYY"));
            setAppointmentHour(dayjs(appointment.hora, "HH:mm"));
            setAppointmentDuration(appointment.duracao);
            setAppointmentObservation(appointment.observacao);
            setAppointmentType(appointment.tipo);
            setAppointmentStatusDescription(appointment.descricaoDoStatus);
            setAppointmentStatus(appointment.status);
            setLoading(false);
        })
            .catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }
            });
    }, [navigate]);

    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    
  const openModalToCancelAppointment = (patient) => {
    setShowModalToDeleteAppointment(true);
    closeMenu();
  };

  const closeModalToCancelAppointment = () => {
    setShowModalToDeleteAppointment(false);
    setSelectedPatient(null);
  };

    useEffect(() => {
        const dentistIdFromUser = sessionStorage.getItem('dentistIdFromUser');
        if (dentistIdFromUser && dentistIdFromUser !== 'null' && dentistIdFromUser !== 'undefined') {
            setSelectedDentistId(dentistIdFromUser);
        }

        if (appointmentId) {
            getAppointment(appointmentId);
        } else {
            setAppointmentDate(dayjs(appointmentData?.date));
            setAppointmentHour(dayjs(appointmentData?.hour, "HH:mm"));
        }
        getComboBoxPatients();
        getComboBoxDentists();
    }, [getComboBoxPatients, getComboBoxDentists, appointmentData, getAppointment, appointmentId]);

    const saveAppointment = (event) => {
        event.preventDefault();
        setLoading(true);

        if (validateRequiredFields()) {

            const appointment = {
                "pacienteId": selectedPatient.id,
                "dentistaId": selectedDentistId,
                "data": dayjs(appointmentDate).format("DD/MM/YYYY"),
                "hora": dayjs(appointmentHour).format("HH:mm"),
                "duracao": appointmentDuration,
                "observacao": appointmentObservation,
                "tipo": appointmentType,
                "id": appointmentId,
                "telefone": patientPhoneNumber
            };

            if (appointmentId) {
                api.put("/appointments", appointment, {
                    headers: {
                        Authorization: sessionStorage.getItem('token')
                    }
                }).then((returnFromApi) => {
                    setLoading(false);
                    setShowSuccessMessage(true);
                    setSuccessMessage(returnFromApi.data);
                }).catch((returnFromApi) => {
                    setLoading(false);
                    setShowErrorMessage(true);
                    setErrorMessage(returnFromApi.response.data);
                    console.error(returnFromApi);
                });

            } else {
                api.post("/appointments", appointment, {
                    headers: {
                        Authorization: sessionStorage.getItem('token')
                    }
                }).then((returnFromApi) => {
                    setLoading(false);
                    setShowSuccessMessage(true);
                    setSuccessMessage(returnFromApi.data);
                    cleanFields();
                }).catch((returnFromApi) => {
                    setLoading(false);
                    setShowErrorMessage(true);
                    setErrorMessage(returnFromApi.response.data);
                    console.error(returnFromApi);
                });
            }
        }
    }

    function validateRequiredFields() {
        if (!selectedPatient
            || !selectedDentistId
            || !appointmentType
            || !appointmentDuration
            || !appointmentHour
            || !appointmentDate
        ) {
            setShowErrorMessage(true);
            setErrorMessage('Para salvar uma consulta é obrigatório preencher os campos: Paciente, Dentista, Data, Hora, Duração e Tipo');
            setLoading(false);
            return false;
        }
        return true;
    }

    function confirmAppointment() {
        setLoading(true);
        api.post(`/appointments/${appointmentId}/confirm`, {}, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then((returnFromApi) => {
                setLoading(false);
                setShowSuccessMessage(true);
                setSuccessMessage(returnFromApi.data);
                getAppointment(appointmentId);
            })
            .catch((returnFromApi) => {
                setLoading(false);
                setShowErrorMessage(true);
                setErrorMessage(returnFromApi.response.data);
                console.error(returnFromApi);
            });
    }

    function cancelAppointment() {
        setLoading(true);
        api.post(`/appointments/${appointmentId}/cancel`, {}, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then((returnFromApi) => {
                setLoading(false);
                setShowSuccessMessage(true);
                setSuccessMessage(returnFromApi.data);
                getAppointment(appointmentId);
                closeModalToCancelAppointment();
            })
            .catch((returnFromApi) => {
                setLoading(false);
                setShowErrorMessage(true);
                setErrorMessage(returnFromApi.response.data);
                console.error(returnFromApi);
            });
    }

    function cleanFields() {
        setSelectedDentistId('');
        setSelectedPatient(null);
        setAppointmentDate(dayjs());
        setAppointmentHour(dayjs());
        setAppointmentDuration('');
        setAppointmentObservation('');
        setAppointmentType('');
        setPatientPhoneNumber('');
    }

    function goToMedicalRecord() {
        navigate(`/patient-form/${selectedPatient.id}`);
    }

    const whatsAppConfirm = () => {

        if (!selectedPatient || !selectedPatient.id) {
            setShowErrorMessage(true);
            setErrorMessage('Nenhum paciente selecionado.');
            return;
        }

        if (!selectedDentistId) {
            setShowErrorMessage(true);
            setErrorMessage('Nenhum dentista selecionado.');
            return;
        }

        const patientId = selectedPatient.id;

        const dentist = comboBoxDentists.find(d => d.id === selectedDentistId);
        const dentistName = dentist ? dentist.nome : 'seu dentista';

        setLoading(true);

        api.get(`/patients/${patientId}`, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setLoading(false);

            const patientPhone = returnFromApi.data.telefone;

            if (!patientPhone) {
                setShowErrorMessage(true);
                setErrorMessage('Telefone do paciente não encontrado. Verifique o cadastro do paciente.');
                return;
            }

            const phoneNumber = patientPhone.replace(/\D/g, '');
            if (phoneNumber.length < 10) {
                setShowErrorMessage(true);
                setErrorMessage('O número de telefone do paciente parece inválido.');
                return;
            }
            const fullPhoneNumber = `55${phoneNumber}`;

            const date = dayjs(appointmentDate).format("DD/MM/YYYY");
            const time = dayjs(appointmentHour).format("HH:mm");

            const message = `Olá, gostaríamos de confirmar sua consulta com a(o) Dra(o) ${dentistName} no dia ${date} às ${time}h. Por favor, responda "SIM" para confirmar.`;

            const encodedMessage = encodeURIComponent(message);

            window.open(`https://wa.me/${fullPhoneNumber}?text=${encodedMessage}`, '_blank');

        }).catch((returnFromApi) => {
            setLoading(false);
            setShowErrorMessage(true);
            setErrorMessage('Erro ao buscar o telefone do paciente. ' + returnFromApi.message);
            console.error("Erro ao buscar paciente: ", returnFromApi);
        });
    };

    return (
        <Card className="bg-white rounded-4 shadow-lg border-0">
            <Card.Header className="bg-white border-0 py-3">
                <h5 className="mb-0 fw-bold text-muted">Consulta</h5>
            </Card.Header>

            <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            <Card.Body>
                <Form onSubmit={saveAppointment}>
                    <Box sx={{ width: '100%' }}>
                        <Grid container spacing={2} sx={{ mb: 1 }}>
                            <Grid item size={12}>
                                <Stack direction="horizontal" gap={2}>
                                    {appointmentStatus === "SCHEDULED" && (
                                        <Badge pill bg="info">
                                            {appointmentStatusDescription}
                                            <CalendarCheck size={15} />
                                        </Badge>
                                    )}
                                    {appointmentStatus === "CONFIRMED" && (
                                        <Badge pill bg="primary">
                                            {appointmentStatusDescription}
                                            <Check size={15} />
                                        </Badge>
                                    )}
                                    {appointmentStatus === "PERFORMED" && (
                                        <Badge pill bg="success">
                                            {appointmentStatusDescription}
                                            <Check size={15} />
                                        </Badge>
                                    )}
                                    {appointmentStatus === "CANCELED" && (
                                        <Badge pill bg="danger">
                                            {appointmentStatusDescription}
                                            <Ban size={15} />
                                        </Badge>
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <FormControl fullWidth sx={{ flexGrow: 1 }}>
                            <Autocomplete
                                        disablePortal
                                        options={comboBoxPatients}
                                        getOptionLabel={(option) => option.label ?? ""}
                                        filterOptions={filter}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Paciente" />
                                        )}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.id}>
                                                {option.label}
                                            </li>
                                        )}
                                        value={selectedPatient}
                                        onChange={(_, newValue) => setSelectedPatient(newValue ?? null)}
                                        noOptionsText="Paciente não encontrado. Clique em Novo Paciente para fazer o cadastro."
                                    />
                                    </FormControl>
                                    {/* <Select
                                        labelId="patient-combobox-label"
                                        id="patient-combobox"
                                        value={selectedPatientId}
                                        label="Paciente"
                                        onChange={(e) => setSelectedPatientId(e.target.value)}>

                                        {comboBoxPatients.map((patient) => (
                                            <MenuItem value={patient.id}>{patient.nome}</MenuItem>
                                        ))}
                                    </Select> */}

                                    <Button
                                        variant="outlined"
                                        onClick={() => navigate('/patient-form')}
                                        sx={{ 
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0,
                                        }}
                                    >
                                        Novo Paciente
                                    </Button>
                               </Box>
                        <Grid container spacing={2}>
                            <Grid item size={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="dentist-combobox-label">Dentista</InputLabel>
                                    <Select fullWidth
                                        labelId="dentist-combobox-label"
                                        id="dentist-combobox"
                                        value={selectedDentistId}
                                        label="Dentista"
                                        onChange={(e) => setSelectedDentistId(e.target.value)}>

                                        {comboBoxDentists.map((dentist) => (
                                            <MenuItem value={dentist.id}>{dentist.nome}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item size={4}>
                                <FormControl fullWidth>
                                    <DatePicker
                                        label="Data"
                                        value={appointmentDate}
                                        onChange={(newValue) => setAppointmentDate(newValue)}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item size={4}>
                                <FormControl fullWidth>
                                    <TimeField
                                        label="Hora de Início"
                                        value={appointmentHour}
                                        onChange={(newValue) => setAppointmentHour(newValue)}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item size={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        label="Duração(min)"
                                        type="number"
                                        value={appointmentDuration}
                                        onChange={(e) => setAppointmentDuration(e.target.value)}
                                        fullWidth />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item size={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Observações"
                                        multiline
                                        rows={4}
                                        value={appointmentObservation}
                                        onChange={(e) => setAppointmentObservation(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item size={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="type-combobox-label">Tipo</InputLabel>
                                    <Select
                                        labelId="type-combobox-label"
                                        id="type-combobox"
                                        value={appointmentType}
                                        label="Tipo"
                                        onChange={(e) => setAppointmentType(e.target.value)}>

                                        <MenuItem value="INVALIDO">Selecione o tipo</MenuItem>
                                        <MenuItem value="AVALIACAO">Avaliação</MenuItem>
                                        <MenuItem value="CIRURGIA">Cirurgia</MenuItem>
                                        <MenuItem value="DENTISTICA">Dentística</MenuItem>
                                        <MenuItem value="ENDODONTIA">Endodontia</MenuItem>
                                        <MenuItem value="HOF">HOF</MenuItem>
                                        <MenuItem value="PROTESE">Prótese</MenuItem>
                                        <MenuItem value="RETORNO">Retorno</MenuItem>
                                        <MenuItem value="ODONTOPEDIATRA">Odontopediatra</MenuItem>
                                        <MenuItem value="ORTODONTIA">Ortodontia</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Box>
                            <Button
                                variant="outlined"
                                onClick={() => goToMedicalRecord()}
                                disabled={!appointmentId}
                                sx={{
                                    top: '35px'
                                }}
                            >
                                Prontuário
                            </Button>


                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                                <Box sx={{ display: 'flex', gap: 1.5 }}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => navigate('/agenda')}
                                    >
                                        Voltar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={appointmentId && appointmentStatus !== "SCHEDULED"}
                                    >
                                        Salvar
                                    </Button>

                                    {appointmentId && (
                                        <>
                                            <Button
                                                aria-controls={anchorEl ? 'patient-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={anchorEl ? 'true' : undefined}
                                                onClick={openMenu}
                                                variant="outlined"
                                            >
                                                <MoreVertIcon />
                                            </Button>
                                            <Menu
                                                id="patient-menu"
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={closeMenu}
                                            >
                                                 <MenuItem onClick={() => confirmAppointment()}
                                                    disabled={appointmentStatus !== "SCHEDULED"}>
                                                    Confirmar Consulta
                                                </MenuItem>

                                                <MenuItem onClick={() => openModalToCancelAppointment()}
                                                    disabled={appointmentStatus === "CANCELED"}
                                                >
                                                    Cancelar Consulta
                                                </MenuItem>

                                                <MenuItem
                                                    onClick={() => {
                                                        whatsAppConfirm();
                                                    }}
                                                    disabled={
                                                        appointmentStatus === "CANCELED" ||
                                                        appointmentStatus === "PERFORMED"
                                                    }
                                                    sx={{ color: 'success.main' }}
                                                >
                                                    <ListItemIcon>
                                                        <WhatsApp
                                                            fontSize="small"
                                                            sx={{ color: 'success.main' }}
                                                        />
                                                    </ListItemIcon>
                                                    Enviar pelo WhatsApp
                                                </MenuItem>
                                            </Menu>
                                        </>
                                    )}
                                </Box>
                            </Box>

                        </Box>
                    </Box>
                </Form>
                  <Dialog
                        open={showModalToCancelAppointment}
                        onClose={closeModalToCancelAppointment}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title">{"Confirmar Cancelamento"}</DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            Tem certeza de que deseja cancelar a consulta?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={closeModalToCancelAppointment}>Não</Button>
                          <Button onClick={cancelAppointment} sx={{ color: 'error.main' }}>
                            Sim
                          </Button>
                        </DialogActions>
                      </Dialog>

            </Card.Body>
        </Card>
    );

}

export default Appointment;